const { default: styled } = require('styled-components');

export const GoogleButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
